import theme from "theme";

const { default: styled } = require("@emotion/styled");

const CardContainerStyle = styled.div`
  padding: 0px 16px 16px 16px;
`;

const HeaderStyle = styled.div`
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333333;
`;

const RowContainerStyle = styled.div`
  // display: grid;
  // grid-template-columns: repeat(2, 1fr); /* Two columns */
  // gap: 8px; /* space between items */
`;
const RowContainerStyleSub = styled.div`
  display: grid;
  grid-template-columns: 0.33fr 1fr; /* label | content */
  align-items: start; /* aligns top */
  padding: 4px;
  margin: 8px 0px;
`;

const RowStyle = styled.div`
  flex: 1 1 40%;
  font-size: 14px;
  color: #555555;
  padding: 4px;
  display: flex;
  align-items: center;
`;

const LabelContainerStyle = styled.span`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  font-weight: 500;
  color: black;
  font-size: 13px;
`;

const ValueContainerStyle = styled.span`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  color: #666666;
  font-size: 13px;
`;

const LeasingLayout = styled.div`
  margin-top: 50px;
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const Button = styled.button`
  min-width: 90px;
  height: 25px;
  border-radius: 5px;
  font-size: 12px;
  color: black;
  cursor: pointer;
  background: white;
  outline: none;
  border: none;
  border: 1px solid black;

  &:hover {
    color: ${theme.colors.themeColor};
    background: white;
  }
`;

const SC = {
  CardContainerStyle,
  HeaderStyle,
  RowContainerStyle,
  RowStyle,
  LabelContainerStyle,
  ValueContainerStyle,
  LeasingLayout,
  BodyHeader,
  Button,
  RowContainerStyleSub,
};

export default SC;
